import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Heading, Text } from '@chakra-ui/react';
import SectionTitle from '../../components/shared/SectionTitle';
import TwoColumns from '../../components/shared/TwoColumns';
import 'react-image-gallery/styles/css/image-gallery.css';

const OurPeopleSection = () => (
  <Box id="our-people" my="20">
    <Box maxW="5xl" mx="auto">
      <SectionTitle
        title="Our People"
        subTitle="HOVER's employees are our top priority and drive our success. That's why we invest in employee's personal and professional growth, fund and prioritize employee-led diversity and inclusion work, and support work-life balance. We are committed to building and sustaining a company culture where all HOVERites experience a sense of belonging, are inspired by their peers, and love their work."
      />
    </Box>
    <TwoColumns
      maxColWidth="600px"
      col1={
        <StaticImage
          src="../../images/our_people_1-min.jpg"
          placeholder="blurred"
          alt="HOVER employees posing for a photo"
        />
      }
      col2={
        <Box>
          <Heading>Growth, Learning, and Development</Heading>
          <Text my="10" fontSize="lg">
            HOVER’s robust L&D program supports the greater culture of learning
            that exists at HOVER. Employees are given the tools and time to
            learn new skills, hear from industry experts, and advance in their
            careers. Employees personalize their growth with regular in-house
            offerings, dedicated time for self-directed learning, leadership
            coaching, generous per-employee funding for outside opportunities,
            and more.
          </Text>
        </Box>
      }
    />
    <TwoColumns
      maxColWidth="600px"
      reverseOrderInMobile
      col1={
        <Box>
          <Heading>Diversity and Inclusion</Heading>
          <Text my="10" fontSize="lg">
            A diverse HOVER where employees experience true inclusion is good
            for employees and critical to our success. From recruitment
            practices that reduce the impact of systemic inequities to
            supporting the exemplary educational, policy, and community work of
            our employee-led D&I Committee, we are committed to addressing bias
            and fostering belonging at HOVER.
          </Text>
        </Box>
      }
      col2={
        <StaticImage
          src="../../images/our_people_2-min.jpg"
          placeholder="blurred"
          alt="HOVER Employees at a large outdoor event"
        />
      }
    />
    <TwoColumns
      maxColWidth="600px"
      col1={
        <StaticImage
          src="../../images/our_people_3-min.jpg"
          placeholder="blurred"
          alt="HOVER employees posing with flexed arms"
        />
      }
      col2={
        <Box>
          <Heading>Wellness</Heading>
          <Text my="10" fontSize="lg">
            We believe in work/life balance. We offer flexible work policies and
            seek to build warm, collegial relationships with one another
            regardless of role or location. We have monthly “Self-Care Days,” a
            paid day off, and a competitive suite of Health & Wellness benefits
            to support employees and their families at all stages of life.
          </Text>
        </Box>
      }
    />
  </Box>
);

export default OurPeopleSection;
